import React from 'react'
import { Input, Ref, Dimmer, Loader } from 'semantic-ui-react'
import readXlsxFile from 'read-excel-file'
import ImportModal from './ImportModal'
import { setSharedState } from '../../utilities/sharedState'
import { Redirect } from 'react-router-dom'
import { createMapping, getColumnHeadersFromWorksheet } from '../../utilities/worksheet'
import { skipColum, importColumns } from '../../utilities/columnNames'

export default class CreateOrder extends React.Component {

  constructor(props, ctx) {
    super(props, ctx)
    this.state = {
      showImportModal: false,
      excelRows: [],
      loading: false,
      goToProductDetail: false,
      mappings: [],
      response: ''
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    delete this.fileRef
  }

  handleReadFile = (e) => {
    this.setState(state => ({
      ...state,
      loading: true
    }))

    readXlsxFile(e.target.files[0]).then((rows) => {
      this.fileRef.value = null
      // create automapping
      const headers = getColumnHeadersFromWorksheet(rows)
      const autoMappings = createAutoMappings(headers, importColumns)
      // debugger

      this.setState((state) => ({
        ...state,
        loading: false,
        showImportModal: true,
        excelRows: rows,
        mappings: autoMappings
      }))
    })
  }

  handleRef = (ref) => {
    if (!this.fileRef) {
      if(ref)
      this.fileRef = ref.children[0]
    }
  }

  handleImportCancellation = () => {
    this.setState((state) => ({
      ...state,
      excelRows: [],
      showImportModal: false
    }))
  }

  handleImport = () => {
    const excelRows = this.state.excelRows
    const mappings = this.state.mappings
    this.setState((state) => ({
      ...state,
      excelRows: [],
      showImportModal: false,
      goToProductDetail: true
    }), () => {
      // move excel rows and mappings to the shared state
      // to make it visible for product detail view
      setSharedState({
        importedExcelRows: excelRows,
        importedExcelMappings: mappings
      })
    })
  }

  handleAddMapping = (from, to) => {
    this.setState(state => {
      const nextMapping = createMapping(from, to)
      const cleanMappings = state.mappings.filter(mapping => {
        if (nextMapping.from === mapping.from) {
          return false
        }
        if (mapping.to === skipColum.value) {
          return false
        }
        if (mapping.to === nextMapping.to) {
          return false
        }
        return true
      })

      const nextMappings = [...cleanMappings, nextMapping]

      return {
        mappings: nextMappings
      }
    })
  }

  render() {
    if (this.state.goToProductDetail) {
      return <Redirect to='/products/new' />
    }

    return (
      <div>
        <Ref innerRef={this.handleRef}>
          <Input type='file' onInput={this.handleReadFile}></Input>
        </Ref>
        <Dimmer active={this.state.loading} inverted>
          <Loader inverted>Loading...</Loader>
        </Dimmer>
        <ImportModal
          open={this.state.showImportModal}
          mappings={this.state.mappings}
          excelRows={this.state.excelRows}
          onCancel={this.handleImportCancellation}
          onImport={this.handleImport}
          onAddMapping={this.handleAddMapping}
          columnNames={importColumns}
        />
      </div>
    )
  }
}

function createAutoMappings(headers, importColumns) {
  return headers.map(headerName => {
    const candidate = importColumns.find(col => (
      cleanTextToCompare(col.text) === cleanTextToCompare(headerName) ||
      cleanTextToCompare(col.value) === cleanTextToCompare(headerName)
    ))

    if (candidate) {
      return createMapping(headerName, candidate.value)
    } else {
      return createMapping(headerName, skipColum.value)
    }
  })
}

function cleanTextToCompare(txt) {
  return String(txt).toLowerCase().replace(/[^A-Za-z]/g, '');
}



// WEBPACK FOOTER //
// ./components/create-order/CreateOrder.js